module.exports = __webpack_public_path__ + "img/moneyTrial123.5be57b1c.png";